import { render, staticRenderFns } from "./BaseSingleTemplate.vue?vue&type=template&id=4c2c92c6&scoped=true&"
import script from "./BaseSingleTemplate.vue?vue&type=script&lang=js&"
export * from "./BaseSingleTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BaseSingleTemplate.vue?vue&type=style&index=0&id=4c2c92c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c92c6",
  null
  
)

export default component.exports